import { McIcon } from "./icon.js"



export class McIconArrowBr extends McIcon {

  constructor() {
    super()
    const templ = document.createElement("template")
    templ.innerHTML = `
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-arrow-down-right h-5 w-5 text-blue-600" aria-hidden="true">
  <path d="m7 7 10 10"></path>
  <path d="M17 7v10H7"></path>
</svg>
`
    super.addHTML(templ)
  }
}



if (!window.customElements.get("mc-icon-arrow-br")) window.customElements.define("mc-icon-arrow-br", McIconArrowBr)
